<mat-form-field>
  <mat-label>{{'Status' | translate}}</mat-label>
  <app-status [statusText]="status"></app-status>
  <input [value]="status" matInput type="text" readonly hidden>
</mat-form-field>
